import React from 'react';
import PropTypes from 'prop-types';
import GetBackgroundColor from 'Common/Functions/GetBackgroundColor';

import Icon, { IndicatorDot } from './styled';

const getLetter = (word) => {
  if (word) {
    if (word.length === 1) return word;

    return word[0];
  }
  return '-';
};

const ColorImage = ({
  role, title = '-', initials = '', size = 40, hasIndicator = false, indicatorBorderColor = undefined
}) => {
  const background = GetBackgroundColor(role);
  const letter = initials || getLetter(title);

  return (
    <Icon background={ background } title={ title } size={ size }>
      {letter}
      {hasIndicator && <IndicatorDot borderColor={ indicatorBorderColor } />}
    </Icon>
  );
};

ColorImage.propTypes = {
  role: PropTypes.string.isRequired,
  title: PropTypes.string,
  initials: PropTypes.string,
  size: PropTypes.number,
  hasIndicator: PropTypes.bool,
  indicatorBorderColor: PropTypes.string
};

export default ColorImage;
